import styled, { css } from 'styled-components';
import { ReactComponent as _QuestionIcon } from './icons/question-icon.svg';
import { ReactComponent as _CloseIcon } from './icons/close-icon.svg';
import { ReactComponent as _CheckIcon } from './icons/check-circle.svg';

import { typography } from 'styles/settings';

export const IconContainer = styled.div`
  margin-right: 6px;
`;

export const Label = styled.span`
  ${typography.font.medium};
  font-size: ${typography.size.md};
  padding-top: 2px;
`;

const iconStyle = css`
  width: 22px;
  height: 22px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 40px;
`;

export const QuestionIcon = styled(_QuestionIcon)`
  ${iconStyle};
`;

export const CloseIcon = styled(_CloseIcon)`
  ${iconStyle};
`;

export const CheckIcon = styled(_CheckIcon)`
  ${iconStyle};
`;
